<template>
  <div class="exhibition-details" v-if="companyInfo">
    <div v-wechat-title="$route.meta.title=companyInfo.exInfo.shortName || companyInfo.exInfo.compName"></div>
    <img class="ex_details_bg" src="@/assets/img/ex_default_bg.jpg" >
    <navigation2 :companyInfo="companyInfo" @add="add()"></navigation2>
    <div class="ed-banner">
      <!-- :autoplay="3000" -->
      <van-swipe class="my-swipe" :show-indicators="false" @change="swiperChange" :autoplay="isAutoplay" >
        <van-swipe-item v-for="(item,index) in proShowList.slice(0,3)" :key="index" >
          <videoPlayer v-if="item.video && item.video.Link" ref="videoPlays" 
          @onPlayerPlay="onVideoPlay" 
          @onPlayerPause="onVideoPause"
          :ind="index" 
          :url="item.video.Link"
          :time="item.video.Time"
          :cover="item.video.Img"
          ></videoPlayer>
          <img :src="item.banner[0]" v-else v-load="'oPjtBig'">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="ed-title">
      <h3>诚邀您莅临参观</h3>
    </div>
    <div class="ed-list" :class="proShowList.slice(0,3).length<3?'isNo3':''">
      <div class="card" v-for="(item,index) in proShowList.slice(0,3)" :key="index" @click="LinkProduct(item.id)">
        <div class="card-box" :class="{is_active:index==swiperIndex}">
          <img
            :src="item.banner[0]"
            v-load="'oPjtThn'"
          />
        </div>
        <div class="card-txt">{{item.name}}</div>
      </div>
     
    </div>
    <div class="ed-info">
      <div v-for="(item,index) in companyInfo.busList.slice(0,2)" :key="'b'+index">
        <p>{{item.remark}}<span @click="openInquiry" v-if="item.isSample">索取样品</span></p>
      </div>
    </div>
    <!-- 询盘 -->
    <inquiry ref="inquiry"></inquiry>
    <liveTool2 ref="liveTool2"></liveTool2>
    <!-- <liveTool3></liveTool3>  直播状态&洽谈状态 -->
  </div>
</template>

<script>
// import { videoPlayer } from "vue-video-player";
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import inquiry from "@components/inquiry";
import liveTool2 from "@/components/live-tool2/index";
// import liveTool3 from "@/components/live-tool3/index";
import navigation2 from "@/components/navigation2/index";
import videoPlayer from "./videoPlayer";
import {mapGetters, mapActions} from "vuex";
export default {
  name: "exhibition-details",
  data() {
    return {
      list: [],
      swiperIndex:0,    //轮播index
      isAutoplay:300000,      //是否自动播放
      autoPlayVal:300000,
      loading: false,
      finished: false,
      companyInfo:null,
      proShowList:[],
    };
  },
  components: {
    navigation2,
    liveTool2,
    inquiry,
    videoPlayer
  },
  computed: {
    ...mapGetters({
      exhibitorId:'company/getExhibitorId',
      companyId:'company/getCompanyId',
      userId:'getUserId',
      userInfo: "getUserInfo",
      exhibitionId:'getExhibitionId'
    }), 
    exhibitorId(){
      return this.$route.query.exhibitorId;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getCompany:'company/getCompany',
      getProListByCompId:'company/getProListByCompId',
      getProListByTj:'company/getProListByTj',
      getAllCompany:'company/getAllCompany',
      LinkProduct:'linkTo/LinkProduct',
      LinkExhibitionDetails:'linkTo/LinkExhibitionDetails',
      addCompView:'company/addCompView',
    }),
    async init(){
      let body = {
        id:this.exhibitorId,
        userId:this.userId || null,
      }
      this.companyInfo = await this.getAllCompany(body);
      console.log(this.companyInfo);
      this.companyInfo.proList.map(c =>{
        if(c.isDisplay){
          if (c.banner.search(/^\[/) !== -1) {
            c.banner = JSON.parse(c.banner);
          } else {
              c.banner = [];
          } 
          if(c.video && c.video.indexOf('{') !== -1){
              c.video = JSON.parse(c.video);
          }
          this.proShowList.push(c);
        }
      })
      this.$store.commit('company/setExhibitorId',this.companyInfo.exInfo.exhibitorId);
      this.$store.commit('company/setCompanyId',this.companyInfo.exInfo.compId);
      // document.title =  this.companyInfo.exInfo.shortName || this.companyInfo.exInfo.compName;
      this.$nextTick(()=>{
        this.$refs.liveTool2.getShareData(this.companyInfo.exInfo);
      })
      this.addView();
      this.checkForm();
    },
    checkForm(){
      let userInfo = {
          name: this.userInfo.nickName || this.userInfo.name,
          avatarUrl: this.userInfo.avatarUrl
        };
      if(this.$route.query.hotId){
        this.$store.commit('wxShare/setFromType',2);  // 判断是否来源于热榜
        let body = {
          popularzeId: this.$route.query.hotId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
          fromType: 2,
        }
        this.$store.commit('wxShare/setFromData',body);
      } else {
        this.$store.commit('wxShare/setFromType',0);
        let body = {
          compId: this.companyId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.exhibitorId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
          fromType: 0,
        }
        this.$store.commit('wxShare/setFromData',body);
      }
    },
    addView(){
      // 添加浏览记录
      let userInfo = {
        nickName: this.userInfo.nickName,
        avatarUrl: this.userInfo.avatarUrl
      };
      let body = {
        compId: this.companyId,
        exhibitionId: this.exhibitionId,
        exhibitorId: this.exhibitorId,
        userId: this.userId,
        userInfo: JSON.stringify(userInfo)
      };
      this.addCompView(body);
    },
    add(){ // 增加关注
      this.init();
    },
    //点击索取样品，打开询盘
    openInquiry(){
      this.$refs["inquiry"].open();
    },
    //轮播改变
    swiperChange(index){
      this.swiperIndex=index;
      if(this.isAutoplay=='-')
      {
        //如果改变的时候视频正在播放，则暂停
        this.$refs.videoPlays.forEach((element,ind) => {
          element.swiperChange()
        });
        this.isAutoplay=this.autoPlayVal;
      }
      // if(this.isAutoplay!="-"){
      // }
    },
    //视频播放
    onVideoPlay(){
      this.isAutoplay="-";
    },
    //视频暂停
    onVideoPause(index){
      if(this.swiperIndex==index){
        this.isAutoplay=this.autoPlayVal;
      }
    },
    //视频结束
    // onVideoEnd(e){
    //   console.log('结束');
    //   this.isAutoplay=this.autoPlayVal;
    // }
  },
  destroyed() {
    this.$store.commit('wxShare/setFromData',null);
    this.$store.commit('wxShare/setFromType',0); 
  },
};
</script>

<style scoped lang="scss">
.exhibition-details {
  height: 100vh;
  background: url(../../assets/img/live/bg2.png);
  position: relative;
  background-size: cover;
  overflow: hidden;
  .ex_details_bg{
    position: absolute;
    // object-fit: cover;
    filter: blur(0.1rem); 
    width: 100%;
    height: 100%;
  }
  .ed {
    &-banner {
      border-radius: 0.2rem;
      overflow: hidden;
      width: 6.9rem;
      height: 3.86rem;
      background-color: rgba(#000, 0.35);
      margin: 1rem auto 0;
    }
    &-title {
      text-align: center;
      margin-top: 0.5rem;
      margin-bottom: 0.33rem;
      color: #fff;
      position: relative;
      h3 {
        font-size: 0.3rem;
        display: inline-block;
        padding: 0 0.45rem;
        background-image: url(../../assets/img/live/icon-title-left.png),
          url(../../assets/img/live/icon-title-right.png);
        background-position: left center, right center;
        background-repeat: no-repeat;
        background-size: 0.34rem 0.24rem, 0.35rem 0.24rem;
      }
    }
    &-list {
      padding: 0 0.3rem;
      display: flex;
      justify-content: space-between;
      position: relative;
      &.isNo3{
        &::after{
        content: '';
        width: 2rem;
        }
      }
    }
    &-info {
      margin-left: 0.3rem;
      width: 4.82rem;
      margin-top: 0.4rem;
      position: relative;
      div{
        margin-bottom: 0.14rem;
        p{
          display: inline-block;
          padding:0.1rem 0.1rem;
          line-height:0.3rem;
          border-radius: 0.03rem;
          background: rgba(0,0,0,0.4);
          color: #fff;
          span{
            text-decoration: underline;
            margin-left: 0.18rem;
            color: #199bff;
          }
        }
      }
    }
  }
  .my-swipe {
    .van-swipe-item {
      color: #fff;
      font-size: 0.2rem;
      height: 3.86rem;
      text-align: center;
      background-color: #fff;
      img {
        width: 100%;
        height: 100%;
      }
      &::v-deep .video-player{
        .vjs-poster{
          background-size: cover;
        }
      }
    }
  }
}
.container {
  background-color: #f5f5f5;
  min-height: 100%;
}
.video_box,
.container,
.player,
.video-player {
  height: 100%;
}

.card {
  // width: 2rem;
  width: 29%;
  border-radius: 10px;
  &-box {
    width: 100%;
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 100%;
    border:1px solid rgba(0,0,0,0);
    border-radius: 0.1rem;
    overflow: hidden;
    &::after{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.7);
    }
    img {
      width: 100%;
      height: 100%;
      // object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // object-fit: cover;
    }
    &.is_active{
      border-color:#fe5502; 
      &::after{
        display: none;
      }
    }
    
  }
  &-txt {
    font-size: 0.2rem;
    color: #fff;
    padding: 0.2rem 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
